import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

export function useCancelPlanMutation({ onError, onSuccess, onSettled } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return http.delete(HTTP_ENDPOINTS.chartSmart.cancelSubscriptionPlan());
    },
    onSuccess: () => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.subscriptionDetail],
      });
    },
    onError: () => {
      onError?.();
    },
    onSettled: () => {
      onSettled?.();
    },
  });
}
